import { HubConnection } from '@microsoft/signalr'
import { AppDispatch } from '../types/store'
import { SignalRMethods } from './lib/SignalRMethods'
import { logOnSignalRMethodTrigger } from './lib/logOnSignalRMethodTrigger'
import { IActionHistory } from '../types/actionsTypes'
import { actionsActions } from '../store/slices/actionsSlice'

export const receiveActionUpdate = (
    connection: HubConnection,
    dispatch: AppDispatch
) => {
    connection.on(SignalRMethods.ACTION_UPDATE, (action: IActionHistory) => {
        logOnSignalRMethodTrigger(SignalRMethods.ACTION_UPDATE, action)

        const { action_id, product_id } = action || {}

        if (action_id && product_id) {
            dispatch(actionsActions.updateAction({ action }))
        }
    })
}